import { useEffect } from "react";
import { useLocation } from "react-router";
import { siteUrl } from "../data/site";
export const siteTitle =
  "Darren | Creative Front-End Developer and 3D Web Developer";
export default function Metadata({
  title = siteTitle,
  description = "Darren Hayden’s portfolio: websites, interactive 3D projects, and notes on how they were built. Based in Colorado.",
  noIndex = false,
}: {
  title?: string;
  description?: string;
  noIndex?: boolean;
}) {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = title;
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute("content", description);
    document
      .querySelector('meta[property="og:title"]')
      ?.setAttribute("content", title);
    document
      .querySelector('meta[property="og:description"]')
      ?.setAttribute("content", description);
    let robots = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (noIndex) {
      if (!robots) {
        robots = document.createElement("meta");
        robots.name = "robots";
        document.head.append(robots);
      }
      robots.content = "noindex";
      document.querySelector('link[rel="canonical"]')?.remove();
      document.querySelector('meta[property="og:url"]')?.remove();
      return;
    }
    robots?.remove();
    let canonical = document.querySelector<HTMLLinkElement>(
      'link[rel="canonical"]',
    );
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.append(canonical);
    }
    canonical.href = new URL(pathname, siteUrl).href;
    let socialUrl = document.querySelector<HTMLMetaElement>('meta[property="og:url"]');
    if (!socialUrl) {
      socialUrl = document.createElement("meta");
      socialUrl.setAttribute("property", "og:url");
      document.head.append(socialUrl);
    }
    socialUrl.content = canonical.href;
    document
      .querySelector('meta[property="og:image"]')
      ?.setAttribute("content", new URL("/social-preview.png", siteUrl).href);
  }, [title, description, pathname, noIndex]);
  return null;
}
